import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import minBy from 'lodash/minBy'

function filterPrices (prices) {
  return prices.filter(price => {
    const samePrice = prices.filter(other => other !== price && other.price === price.price)

    // has higher
    if (samePrice.findIndex(other => other.playersCount > price.playersCount) >= 0) {
      return false
    }

    const minPlayersCount = minBy(samePrice, ({ price }) => price)

    if (minPlayersCount) {
      price.label = `${minPlayersCount.playersCount}-${price.playersCount}`
    }

    return true
  })
}

export default function PricingDropdown ({ room, prices, isOpen, onSelect }) {
  if (!isOpen) return null
  const { playersCountingSystem } = room

  const options = useMemo(() => {
    return filterPrices(prices).map(pricing => {
      return (
        <li key={pricing.playersCount}>
          <button
            type="button"
            onClick={() => { onSelect(pricing.playersCount) }}
          >
            {pricing.label || pricing.playersCount} - ${pricing.price}
          </button>
        </li>
      )
    })
  }, [prices])

  return (
    <div
      className={classNames('select_players_count_dropdown', { 'is-open': isOpen })}
    >
      <div className="title">{playersCountingSystem}:</div>
      <ul className="list">{options}</ul>
    </div>
  )
}

PricingDropdown.propTypes = {
  room: PropTypes.object.isRequired,
  prices: PropTypes.array.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired
}
